import React from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import RouteConstants from '../../common/RouteConstants';

import Typography from '@mui/material/Typography';
import BrokenImageTwoToneIcon from '@mui/icons-material/BrokenImageTwoTone';
import Fab from '@mui/material/Fab';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

import './PageNotFoundUI.css';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flexGrow: 1,
        alignSelf: 'center',
        width: '100%',
        height: '100vh',
        backgroundColor: theme.palette.background.default
    },
    icon: {
        color: theme.palette.primary.light,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '10rem !important',
        marginBottom: theme.spacing(3),
    },
    subtext: {
        marginTop: theme.spacing(1),
        width: '250px',
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    fabHome: {
        margin: theme.spacing(1)
    }
}));

const PageNotFoundUI = (props) => {

    const classes = useStyles();
    const navigate = useNavigate();

    const gotoHome = () => {
        navigate(RouteConstants.COACH_PROFILE_VIEW);
    }

    return (
        <div className={classes.root}>
            <BrokenImageTwoToneIcon className={classes.icon} />

            <Typography variant="h6" color="primary">Oops!</Typography>
            <Typography variant="body1" className={classes.subtext}>We can't seem to find the page you're looking for.</Typography>

            <br /><br />
            <Fab size="medium" color="primary" aria-label="search"
                className={classes.fabHome} onClick={() => gotoHome()}>
                <HomeOutlinedIcon />
            </Fab>
            <br />

        </div>
    )
}

export default PageNotFoundUI;